module.exports = __webpack_public_path__ + "static/media/u8b_5.346be3c6.mp3";